import type * as React from "react";
import { Controller, type Path, useFormContext } from "react-hook-form";
import { default as BaseFormFieldSecret } from "../../vendor/FormFieldSecret.jsx";

export type FormFieldSecretProps = {
  /**
   * The name/type of the secret data, e.g. "password", "CC number".
   * Appears as "Show password", "Hide CC number" etc.
   */
  accessibleCopyName?: string | undefined;

  /**
   * An error message that overrides errors produced by built-in validation.
   */
  error?: { message: string } | undefined;

  ariaLabelText?: string | undefined;
  className?: string | undefined;
  defaultRevealed?: boolean | undefined;
  disabled?: boolean | undefined;
  helpText?: string | React.JSX.Element | undefined;
  label: string;
  name: string;
  onToggleSecretClick?: ((revealed: boolean) => void) | undefined;
  readonly?: boolean | undefined;
  required?: boolean | undefined;

  /**
   * @internal
   */
  [key: string]: unknown;
};

/**
 * <!-- TODO(ndhoule): Document me -->
 *
 * @internal
 */
export const FormFieldSecret = <
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
  FieldValues extends Record<string, unknown>,
>({
  name,
  label,
  error,
  ...otherProps
}: FormFieldSecretProps) => {
  const { control } = useFormContext<FieldValues>();

  return (
    <Controller
      name={name as unknown as Path<FieldValues>}
      control={control}
      render={({ field, fieldState }) => {
        return (
          <BaseFormFieldSecret
            label={label}
            error={error?.message ?? fieldState.error?.message}
            {...otherProps}
            {...field}
          />
        );
      }}
    />
  );
};
